import { render } from "./SimpleOutput.vue?vue&type=template&id=7003e38c&ts=true&lang=pug"
import script from "./SimpleOutput.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimpleOutput.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__